cv.PayView = Marionette.LayoutView.extend({
  className : 'pay',

  template: cv.Templates['pay/pay'],

  regions: {
    region_content : '#region-content'
  },

  behaviors: [{
    behaviorClass: cv.NotificationBehavior
  }],

  events: {
    'click .pay-close' : 'payClose',
    'click .prev' : 'previous',
    'click .next' : 'next'
  },

  bindings : {
    '.pay__review' : {
      observe : ['amount','tip','recurring','recipient'],
      update: function($el, value, model, options) {
        this.renderReview($el, value, model, options);
      }
    }
  },

  childEvents: {
    // This callback will be called whenever a child is rendered or emits a `render` event
    show : function() {
      // Remove notifications
      vent.trigger('notif:clear');
    },
    render : function() {
    }
  },

  initialize: function(options){
    this.options = _.extend(this.options, options);

    // Set the initial screen variables
    this.current_screen = 'pay_amount';
    this.recipient = null;
    this.top_padding = isMobile.phone && isMobile.apple.device == false  ? 10 : 0;
    this.previous_charge_text = '';
    this.debounced_func = _.debounce(this.updateSession, 150);

    // Listeners
    this.listenTo(vent, 'pay:prev_screen', this.previousScreen, this);
    this.listenTo(vent, 'pay:next_screen', this.nextScreen, this);
    this.listenTo(vent, 'pay:process_stripe', this.processStripe, this);
    this.listenTo(vent, 'pay:process_paypal', this.processPaypal, this);
    this.listenTo(vent, 'pay:save_cart', this.saveCart, this);
    this.listenTo(vent, 'pay:clear_cart', this.clearCart, this);
    this.listenTo(vent, 'pay:recalculate_iframe', function(){
      console.log('Recalculating iframe height...');

      window.parent.postMessage({
        type: 'recalculate_iframe',
        height: this.$('.pay__dialog').outerHeight()
      }, "*");
    }, this);
    this.listenTo(cv.pay, 'change:project_id change:team_id', function(model){
      // Save team and project to local storage
      vent.trigger('pay:save_cart', {
        project_id : model.get('project_id'),
        team_id : model.get('team_id')
      });

      if(_.isNull(model.get('project_id')) && _.isNull(model.get('team_id'))){
        // Remove recipient and close menu
        cv.pay.set({
          'recipient' : null,
          'recipient_menu': false
        });
      }else{
        // Reload recipient
        this.loadRecipient();
      }
    }, this);
    this.listenTo(cv.pay,'change:submitting_payment', function(){
      if(cv.pay.get('submitting_payment') == true){
        vent.trigger('notif:clear');

        this.$('.pay__bottom .next').addClass('button-disabled');
        this.previous_charge_text = this.$('.pay__bottom .next').html();
        if(cv.campaign.get('payment_processor.type') == 'paypal'){
          this.$('.pay__bottom .next').html('Redirecting to PayPal...');
        }else{
          this.$('.pay__bottom .next').html('Processing...');
        }
      }else{
        this.$('.pay__bottom .next').html(this.previous_charge_text);
        this.$('.pay__bottom .next').removeClass('button-disabled');
      }
    }, this);

    // Receive xpost
    var receiveMessage = _.bind(function(event) {
      // When we receive the command to open
      if(event.data.type == 'open_dialog'){
        console.log('Receiving window message, open_dialog');

        // Reset the screen to the start
        if(this.current_screen != 'pay_complete'){
          this.current_screen = 'pay_amount';
        }

        // Add the base animation layer, then start the animation immediately
        this.$el.addClass('base-anim');
        setTimeout(_.bind(function(){
          // Add the start animation class
          this.$el.addClass('start-anim');

          // Remove the base animation after
          setTimeout(_.bind(function(){
            this.$el.removeClass('base-anim');
          }, this), 200);
        }, this), 10);

        // Boot items only if we are not complete
        this.bootUp();
        if(this.current_screen != 'pay_complete'){
          this.bootUp();
        }
      }
    }, this);
    if (window.addEventListener) {
      window.addEventListener('message', receiveMessage, false);
    } else if (window.attachEvent) {
      window.attachEvent('onmessage', receiveMessage);
    }
    
    console.log('PayView initialized');
  },

  templateHelpers: function () {
    return {
    };
  },

  renderReview: function($el, value, model, options){
    console.log('Updating amount to be charged...');

    // Format the amount for display
    var amount = cv.pay.get('amount');
    var tip = cv.pay.get('tip');

    $el.find('.total').html(accounting.toFixed(accounting.unformat(+amount + +tip), 2));

    // Add currency code
    $el.find('.total').append(' <span>' + cv.campaign.get('currency_code') + '</span>');

    // Add recurring period
    if(cv.pay.get('recurring') == 1){
      $el.find('.interval').html(' <span>monthly recurring donation</span>');
    }else{
      $el.find('.interval').html(' <span>one-time donation</span>');
    }

    // Render the recipient
    var interval = setInterval(_.bind(function(){
      if(cv.pay.get('recipient_loaded') == true){
        // Clear the interval
        clearInterval(interval);

        if(!_.isNull(cv.pay.get('recipient'))){
          $el.find('.recipient').html(' to ' + cv.pay.get('recipient').name)
        }else{
          $el.find('.recipient').html('')
        }
      }
    }, this), 100);
  },

  payClose: function(e){
    e.preventDefault();

    // Remove the classes for opening or showing the modal
    this.$el.addClass('exit-anim');

    setTimeout(_.bind(function(){
      // Reset everything
      this.$el.removeClass('start-anim exit-anim');

      // Send message to close the iframe
      window.parent.postMessage({
        type : 'close_dialog'
      }, "*");
    }, this), 100);
  },

  processStripe: function(result, is_mobile){
    // Trying to pass a fraudulent card by bypass CVC
    if(_.isNull(result.token.card.cvc_check) && result.token.card.tokenization_method !== 'apple_pay'){
      // Show an error message
      vent.trigger('notif:error', 'Your CVC is incorrect.');
      vent.trigger('pay:clear_card');
      return false;
    }

    // Set token ID
    cv.pay.set('token', result.token);

    // Submit for processing
    $.ajax({
      cache: false,
      type: "POST",
      url:  '/pay/process',
      data: cv.pay.toJSON(),
      dataType: "json",
      success: _.bind(function(data){
        if(is_mobile){
          // Delay the completion screen to allow the flyout to leave
          result.complete('success');
          setTimeout(_.bind(function(){
            vent.trigger('pay:clear_cart');
            this.current_screen = 'pay_complete';
            this.renderCurrentScreen();
          }, this), 1250);
        }else{
          vent.trigger('pay:clear_cart');
          this.current_screen = 'pay_complete';
          this.renderCurrentScreen();
        }
      }, this),
      error: _.bind(function(xhr, error){
        if(is_mobile){
          result.complete('fail');
        }
        console.log(xhr.responseText);

        vent.trigger('notif:error', $.parseJSON(xhr.responseText).data);
        vent.trigger('pay:clear_card');
      }, this)
    });
  },

  processPaypal: function(){
    // Removing CC details from model before submitting server side
    cv.pay.unset('cc_name');
    cv.pay.unset('cc_number');
    cv.pay.unset('cc_expire_month');
    cv.pay.unset('cc_expire_year');
    cv.pay.unset('cc_scode');

    // Submit for processing
    $.ajax({
      cache: false,
      type: "POST",
      url:  '/pay/process',
      data: cv.pay.toJSON(),
      dataType: "json",
      success: _.bind(function(data){
        // Redirect to paypal
        top.location = data.data;
      }, this),
      error: _.bind(function(xhr, error){
        // Stop payment submission
        cv.pay.set('submitting_payment', false);

        // Show an error message
        this.current_screen = 'pay_error';
        this.renderCurrentScreen();
      }, this)
    });
  },

  // Event handler for previous clicks
  previous : function(e){
    e.preventDefault();

    vent.trigger('pay:prev_button');
  },

  // Event handler for previous clicks
  next: function(e){
    e.preventDefault();

    vent.trigger('pay:next_button');
  },

  previousScreen: function(){
    console.log('Advancing to previous screen...');

    switch(this.current_screen){
      case 'pay_donor':
        this.current_screen = 'pay_amount';
        break;
      case 'pay_error':
        this.current_screen = 'pay_donor';
        break;
    }

    this.renderCurrentScreen(this.options);
  },

  nextScreen: function(){
    console.log('Advancing to next screen...');

    switch(this.current_screen){
      case 'pay_amount':
        this.current_screen = 'pay_donor';
        break;
      case 'pay_donor':
        if(cv.campaign.get('payment_processor.type') == 'paypal'){
          this.current_screen = 'pay_redirect';
        }else{
          this.current_screen = 'pay_complete';
        }
        break;
    }

    this.renderCurrentScreen(this.options);
  },

  renderCurrentScreen: function(options){
    console.log('Rendering current screen...');

    // Merge any options in and attach the base model
    if(_.isUndefined(options)){
      this.options = _.extend(this.options, {});
    }else{
      this.options =  _.extend(this.options, options);
    }

    // Force scroll to top within modal (just in case)
    $('html, body').scrollTop(0);
    $('#app').scrollTop(0);
    this.$('.pay__bottom').css('visibility', 'hidden');

    // Start exit animation
    this.$('#region-content').addClass('exit');
    this.$el.removeClass('show-review pre-show-review');

    // Adjust the steps section
    setTimeout(_.bind(function(){
      // Show the screen
      switch(this.current_screen){
        case 'pay_amount':
          this.showChildView('region_content', new cv.PayAmountView(this.options));
          break;
        case 'pay_donor':
          this.showChildView('region_content', new cv.PayDonorView(this.options));
          this.$el.addClass('pre-show-review');

          setTimeout(_.bind(function(){
            this.$el.addClass('show-review');
          },this), 50);
          break;
        case 'pay_error':
          this.showChildView('region_content', new cv.PayErrorView(this.options));
          break;
        case 'pay_complete':
          this.showChildView('region_content', new cv.PayCompleteView(this.options));
          break;
      }

      // Remove and start enter animation
      this.$('#region-content').addClass('enter');
      setTimeout(_.bind(function(){
        // Start the fade in
        this.$('#region-content').removeClass('exit enter');

        // Update the colors/styles
        this.updateStyles();

        // Render the bottom
        this.renderBottom();

        // Calculate the height and resize and
        // send this height to the parent iframe if we are embedded
        if(cv.pay.get('iframe_type') == 'embed'){
          vent.trigger('pay:recalculate_iframe');

          if(!_.has(this.options, 'initial_load')){
            window.parent.postMessage({
              type : 'reset_scroll'
            }, "*");
          }else{
            delete this.options.initial_load;
          }
        }

        // Animate the headings
        setTimeout(_.bind(function(){
          this.$('.heading').addClass('animate');
        }, this), 250);
      }, this), 200);
    }, this), 100);
  },

  renderBottom: function(){
    console.log('Rendering bottom...');

    // Reset the bottom
    this.$('.pay__bottom').removeClass('pay__bottom-right');
    this.$('.pay__bottom .next').removeClass('button-disabled');
    this.$('.pay__bottom .prev, .pay__bottom .next').hide();

    switch(this.current_screen){
      case 'pay_amount':
        this.$('.pay__bottom').addClass('pay__bottom-right');
        this.$('.pay__bottom .next').html('Next');
        this.$('.pay__bottom .next').show();
        this.$('.pay__bottom').css('visibility', 'visible');
        break;
      case 'pay_donor':
        this.$('.pay__bottom .prev, .pay__bottom .next').show();
        if(cv.campaign.get('payment_processor.type') == 'stripe'){

          this.$('.pay__bottom .next').html('Charge ' + accounting.toFixed(accounting.unformat(+cv.pay.get('amount') + +cv.pay.get('tip')), 2) + ' ' + cv.campaign.get('currency_code'));
        }
        if(cv.campaign.get('payment_processor.type') == 'paypal'){
          this.$('.pay__bottom .next').html('Pay with PayPal <i class="fa fa-paypal" style="margin-left: 7px;"></i> ');
        }
        this.$('.pay__bottom').css('visibility', 'visible');
        break;
      case 'pay_error':
        this.$('.pay__bottom .prev').show();
        this.$('.pay__bottom').css('visibility', 'visible');
        break;
      case 'pay_complete':
        this.$('.pay__bottom').hide();
        break;
    }
  },

  updateStyles: function(){
    // Change the color based on the background colors
    _.each(this.$('[data-color]'), function(el){
      var el_to_calculate = $(el).data('color');
      if(el_to_calculate == 'self'){
        var text_color_class = cv.idealTextColor(this.$(el).css('background-color'));
      }else{
        var text_color_class = cv.idealTextColor(this.$(el_to_calculate).css('background-color'));
      }
      this.$(el).addClass(text_color_class);
    }, this);
  },

  clearCart: function(){
    // Clear session cookie
    Cookies.remove('cv_cart_s');

    // Clear cart
    localforage.getItem('cv_cart_d').then(function(get_cart_values) {
      console.log('Clear cart function, retrieve cart from local storage:', get_cart_values);

      if(!_.isNull(get_cart_values)){
        // Remove general keys we do not want to store ever
        delete get_cart_values.iframe_type;
        delete get_cart_values.session_id;
        delete get_cart_values.permanent_tracker;
        delete get_cart_values.recipient;
        delete get_cart_values.recipient_loaded;
        delete get_cart_values.recipient_menu;
        delete get_cart_values.submitting_payment;

        // Remove data we do not want to keep between carts
        delete get_cart_values.campaign_id;
        delete get_cart_values.project_id;
        delete get_cart_values.team_id;
        delete get_cart_values.amount;
        delete get_cart_values.comment;
        delete get_cart_values.subscribe;
        delete get_cart_values.anonymous;
        delete get_cart_values.tip;
        delete get_cart_values.tip_percent;
        delete get_cart_values.tip_changed;
        delete get_cart_values.add_tip;
        delete get_cart_values.recurring;
        delete get_cart_values.last_screen;
        delete get_cart_values.giftaid;

        localforage.setItem('cv_cart_d', get_cart_values).then(function (set_cart_values) {
          console.log('Cart found, updating values: ', set_cart_values);
        });
      }
    });
  },

  saveCart: function(data){
    // Abort if we are in a preview window
    if(cv.PRELOADED.preview == 1){
      return;
    }

    var update_session = this.debounced_func;

    localforage.getItem('cv_cart_d').then(function(get_cart_values) {
      console.log('Save cart function, retrieve cart from local storage:', get_cart_values);

      if(!_.isNull(get_cart_values)){
        // Merge the incoming data into the cart
        var update_data = _.extend(get_cart_values, data);

        // Remove keys we do not want to store
        delete update_data.iframe_type;
        delete update_data.session_id;
        delete update_data.permanent_tracker;
        delete update_data.recipient;
        delete update_data.recipient_loaded;
        delete update_data.recipient_menu;
        delete update_data.submitting_payment;

        // Force set the campaign ID (hack, but just in case)
        update_data.campaign_id = cv.PRELOADED.campaign_id;

        localforage.setItem('cv_cart_d', update_data).then(function (set_cart_values) {
          console.log('Cart found, updating values: ', set_cart_values);

          update_session(set_cart_values);
        });
      }else{
        // Remove keys we do not want to store in the cart
        delete data.iframe_type;
        delete data.session_id;
        delete data.permanent_tracker;
        delete data.recipient;
        delete data.recipient_loaded;
        delete data.recipient_menu;
        delete data.submitting_payment;

        // Force set the campaign ID (hack, but just in case)
        data.campaign_id = cv.PRELOADED.campaign_id;

        localforage.setItem('cv_cart_d', data).then(function (set_cart_values) {
          console.log('No cart found, new values: ', set_cart_values);

          update_session(set_cart_values);
        });
      }
    });
  },

  bootUp2: function(cart){
    // Check if our settings conflict with loaded cart (like recurring defaults, etc)
    if(cv.campaign.get('enable_recurring') == 1 && (cv.campaign.get('recurring_default') == 1 || cv.campaign.get('recurring_mandatory') == 1)){
      cart.recurring = 1;
    }

    if(cv.campaign.get('enable_recurring') == 0){
      cart.recurring = 0;
    }

    // If we change the campaign ID then we reset everything
    if(_.has(cart, 'campaign_id') && cart.campaign_id != cv.PRELOADED.campaign_id){
      cart.amount = '';
      cart.campaign_id = cv.PRELOADED.campaign_id;
      cart.project_id = cv.PRELOADED.project_id;
      cart.team_id = cv.PRELOADED.team_id;
      cv.pay.set(cart);
    }else{
      // If we are on the same fundraiser or team, then just reload the cart
      if(_.has(cart, 'project_id') && cart.project_id == cv.PRELOADED.project_id && _.has(cart, 'team_id') && cart.team_id == cv.PRELOADED.team_id){
        cv.pay.set(cart);
      }else{
        cart.project_id = cv.PRELOADED.project_id;
        cart.team_id = cv.PRELOADED.team_id;
        cv.pay.set(cart);
      }
    }

    // Render the current screen
    if(cv.pay.get('iframe_type') == 'embed') {
      this.renderCurrentScreen({
        initial_load: true
      });
    }else{
      this.renderCurrentScreen();
    }

    // Kick off model change
    cv.pay.trigger('change');
  },

  // Everytime the dialog or we load the embed we fire this
  bootUp: function(){
    // Abort boot up if we are in a preview window and just show the first screen
    if(cv.PRELOADED.preview == 1){
      this.renderCurrentScreen({
        initial_load: true
      });
      return;
    }

    // Check if this tracker has been installed
    if(cv.campaign.get('tracker_installed') == false){
      // TODO: Add code to ping back that tracking has been installed
    }

    // Create a session ID prioritizing a passed in value
    var session_expire = new Date(new Date().getTime() + 30 * 60 * 1000); // Set for 30 mins
    if(!_.isNull(cv.PRELOADED.session_id)){
      var session_id = cv.PRELOADED.session_id;
    }else{
      var session_id = Cookies.get('cv_cart_s');
      if(_.isUndefined(session_id)){
        session_id = Math.uuid(32);
        Cookies.set('cv_cart_s', session_id, { expires : session_expire, path: '/' });
      }
    }

    // Create a permanent tracker ID prioritizing a passed in value
    if(!_.isNull(cv.PRELOADED.permanent_tracker)){
      var permanent_tracker = cv.PRELOADED.permanent_tracker;
    }else{
      var permanent_tracker = Cookies.get('cv_cart_p');
      if(_.isUndefined(permanent_tracker)){
        permanent_tracker = Math.uuid(32);
        Cookies.set('cv_cart_p', permanent_tracker, { path: '/' });
      }
    }

    // Set the tracker information into the pay model
    cv.pay.set({
      'session_id' : session_id,
      'permanent_tracker' : permanent_tracker
    }, { silent : true });

    // Cart initial setup
    localforage.getItem('cv_cart_d').then(_.bind(function(get_cart_values) {
      // If we have a cart and loading the same team/project page, then load that cart,
      // otherwise we keep cart values and reset the recipient to whatever the page is
      if(!_.isNull(get_cart_values)){
        console.log('Boot up, retrieved cart from local storage:', get_cart_values);

        this.bootUp2(get_cart_values);
      }else{
        console.log('Boot up, local cart not found, retrieving from DB');

        // Add the loader
        this.$('.pay__dialog').append('<div class="cv-loader-wrapper"><div class="cv-loader"></div></div>');

        // We load the cart from a session if it exists and there is data, otherwise boot with empty cart
        $.ajax({
          cache: false,
          type: "GET",
          url:  '/pay/get_cart',
          data: {
            session_id : cv.pay.get('session_id')
          },
          dataType: "json",
          success: _.bind(function(response){
            this.$('.cv-loader-wrapper').remove();

            localforage.setItem('cv_cart_d', JSON.parse(response.data)).then(_.bind(function(set_cart_values) {
              this.bootUp2(set_cart_values);
            }, this));
          }, this),
          error: _.bind(function(xhr, error){
            this.$('.cv-loader-wrapper').remove();

            this.bootUp2({});
          }, this)
        });
      }
    }, this));

    // Get browser information and track open
    browserReport(function (err, browser_data) {
      if (err) {
        console.log('Trouble getting IP address (blocked or other)...');
      }

      console.log('Browser data: ',browser_data);

      // Create session and page load
      $.ajax({
        cache: false,
        type: "POST",
        url:  '/pay/track_open',
        data: {
          session_id : cv.pay.get('session_id'),
          permanent_tracker : cv.pay.get('permanent_tracker'),
          organization_id : cv.campaign.get('organization.id'),
          campaign_id : cv.campaign.get('id'),
          project_id : cv.pay.get('project_id'),
          team_id : cv.pay.get('team_id'),
          browser_data : JSON.stringify(browser_data)
        },
        dataType: "json",
        success: _.bind(function(data){
        }, this),
        error: _.bind(function(xhr, error){
        }, this)
      });
    });
  },

  updateSession: function(cart_data){
    console.log('Updating session...');

    // Update the cart session
    $.ajax({
      cache: false,
      type: "POST",
      url:  '/pay/save_cart',
      data: {
        session_id : cv.pay.get('session_id'),
        permanent_tracker : cv.pay.get('permanent_tracker'),
        organization_id : cv.campaign.get('organization.id'),
        campaign_id : cv.campaign.get('id'),
        project_id : cv.pay.get('project_id'),
        team_id : cv.pay.get('team_id'),
        cart_data : JSON.stringify(cart_data)
      },
      dataType: "json",
      success: _.bind(function(data){
      }, this),
      error: _.bind(function(xhr, error){
      }, this)
    });
  },

  onAttach: function(){
    // Fix touch event scroll stuff
    if(cv.pay.get('iframe_type') == 'modal' && isMobile.phone && isMobile.apple.device == false){
      /* $('#app').scroll(_.bind(function () {
        if ($('#app').scrollTop() < this.top_padding) {
          $('#app').scrollTop(this.top_padding, 0);
        }

        if ($('#app').scrollTop() + $('#app').innerHeight() > $('#app')[0].scrollHeight - this.top_padding) {
          $('#app').scrollTop($('#app')[0].scrollHeight - $('#app').innerHeight() - this.top_padding, 0);
        }
      }, this)); */
    }

    // Add the mobile scroll fix for specific phones
    if(isMobile.phone && isMobile.apple.device == false){
      //this.$el.addClass('pay-mobile-fix');
    }

    // Bind stickit
    this.stickit(cv.pay);

    // Load recipient
    this.loadRecipient();
  },

  loadRecipient: function() {
    cv.pay.set('recipient_loaded', false);

    // Load the recipient
    if (!_.isNull(cv.pay.get('project_id'))) {
      $.ajax({
        cache: false,
        type: "GET",
        url: cv.api_path + '/projects/' + cv.pay.get('project_id') + '?api_key=' + cv.PRELOADED.public_api_key + '&campaign_id=' + cv.campaign.get('id'),
        dataType: "json",
        success: _.bind(function (response) {
          cv.pay.set('recipient', {
            name : response.data.display_name,
            stub : '/' + response.data.stub,
            photo : cv.photo({
              photo_path: response.data.user.photo_path,
              photo_default: cv.campaign.get('default_fundraiser_photo'),
              url_only: true,
              transforms: {
                fit: 'crop'
              }
            })
          });

          cv.pay.set('recipient_loaded', true);
        }, this),
        error: _.bind(function (xhr, error) {
        }, this)
      });
    }

    if (!_.isNull(cv.pay.get('team_id'))) {
      $.ajax({
        cache: false,
        type: "GET",
        url: cv.api_path + '/teams/' + cv.pay.get('team_id') + '?api_key=' + cv.PRELOADED.public_api_key + '&campaign_id=' + cv.campaign.get('id'),
        dataType: "json",
        success: _.bind(function (response) {
          cv.pay.set('recipient', {
            name : response.data.name,
            stub : '/' + response.data.stub,
            photo : cv.photo({
              photo_path: response.data.photo_path,
              photo_default: cv.campaign.get('default_team_photo'),
              url_only: true,
              transforms: {
                fit: 'crop'
              }
            })
          });

          cv.pay.set('recipient_loaded', true);
        }, this),
        error: _.bind(function (xhr, error) {
        }, this)
      });
    }
  },

  onShow: function(){
    // Trigger iframe loaded
    window.parent.postMessage({
      type : 'iframe_loaded'
    }, "*");

    // Add close button to modal
    if(cv.pay.get('iframe_type') == 'modal'){
      this.$el.prepend('<a href="#" class="pay-close">&times;</a>');
    }

    if(cv.pay.get('iframe_type') == 'embed'){
      // Boot up
      this.bootUp();
    }
  }
});
